import React, { useMemo, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import block from 'bem-cn';

import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/desktop';
import Select from 'components/Select/desktop';

import TableRow from '../TableRow/TableRow';
import TableHead from '../TableHead/TableHead';

import './Table.scss';

const b = block('cashback-history-table-cash');

const Table = ({ currentPage, onPageClick, onItemsOnPageChanged }) => {
  const totalCount = useSelector(state => state.reports.cashbackHistory.count, shallowEqual);
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { cashbackHistory } = useSelector(state => state.reports, shallowEqual);
  const itemsOnPageFilters = [
    { value: 10, name: '10' },
    { value: 25, name: '25' },
    { value: 50, name: '50' },
    { value: 100, name: '100' },
  ];
  const [itemsOnPage, setItemsOnPage] = useState({ value: 10, name: '10' });

  const selectItemChangedHandler = itemValue => {
    setItemsOnPage({ value: itemValue, name: itemValue });
    onItemsOnPageChanged(itemValue);
  };

  const rows = useMemo(
    () => cashbackHistory.data.map(item => <TableRow key={item.id} item={item} locale={locale} />),
    [cashbackHistory, locale],
  );

  return (
    <div className={b()}>
      <div className={b('totals')}>
        <div className={b('totals-item')}>
          <div className={b('totals-head')}>{locale.paidCashback}</div>
          <div className={b('totals-data')}>{cashbackHistory.paid}</div>
        </div>
        <div className={b('totals-item')}>
          <div className={b('totals-head')}>{locale.accumulatedCashback}</div>
          <div className={b('totals-data')}>{cashbackHistory.accumulated}</div>
        </div>
        <div className={b('totals-item')}>
          <div className={b('totals-head')}>{locale.cashbackToBePaid}</div>
          <div className={b('totals-data')}>{cashbackHistory.toBePaid}</div>
        </div>
      </div>

      <div className={b('header')}>
        <span className={b('header-left')}>{locale.result}:</span>
        <div className={b('page-count')}>
          <div className={b('page-count-title')}>{locale.elementsOnPage}:</div>
          <div className={b('page-count-select')}>
            <Select
              paginator
              items={itemsOnPageFilters}
              activeItem={itemsOnPage}
              onChange={selectItemChangedHandler}
              color="grey"
            />
          </div>
        </div>
      </div>
      <div className={b('table')}>
        <TableHead locale={locale} />
        <div className={b('tbody')}>
          {!!rows.length ? rows : <div className={b('no-results')}>{locale.noResults}</div>}
        </div>
        <div className={b('paginator-wrapper')}>
          <div className={b('extra-info')}>
            {cashbackHistory.count || 0} {locale.records}
          </div>
          <PaginatorSwitcher
            count={totalCount}
            currentPage={currentPage}
            onPageClick={onPageClick}
            itemsOnPage={itemsOnPage}
          />
        </div>
      </div>
    </div>
  );
};

Table.propTypes = {
  count: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onItemsOnPageChanged: PropTypes.func,
  onPageClick: PropTypes.func.isRequired,
};

export default Table;
